import React from "react";
import LookupAdmin, { ColorSwatch, ActiveChip } from "../../components/LookupAdmin";

const config = {
  title: "Status de Cliente",
  endpoint: "/client-statuses",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 4 },
    { name: "code", label: "Código", required: true, span: 3, placeholder: "ex: lead" },
    { name: "order", label: "Ordem", type: "number", defaultValue: 0, span: 2 },
    { name: "color", label: "Cor", type: "color", defaultValue: "#6c757d" },
    { name: "icon", label: "Ícone", span: 3 },
    { name: "description", label: "Descrição", span: 9 },
    { name: "isDefault", label: "Padrão", type: "boolean", defaultValue: false },
    { name: "active", label: "Ativo", type: "boolean", defaultValue: true },
  ],
  columns: [
    { key: "order", label: "#" },
    {
      key: "name",
      label: "Nome",
      render: (s) => (
        <>
          <ColorSwatch color={s.color} />
          {s.name}
        </>
      ),
    },
    { key: "code", label: "Código" },
    { key: "description", label: "Descrição" },
    { key: "isDefault", label: "Padrão", render: (s) => (s.isDefault ? "Sim" : "—") },
    { key: "active", label: "Status", render: (s) => <ActiveChip active={s.active} /> },
  ],
};

const ClientStatuses = () => <LookupAdmin config={config} />;

export default ClientStatuses;
